import { useEffect, useState } from 'react'
import useInfiniteScroll from 'react-infinite-scroll-hook'
import { APP_CONSTANTS } from 'src/consumer/constants'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import { getFeatureList } from 'src/consumer/services/featureServices'
import { PublicListingComponentVarOne } from '../ListingPageComponentsAndHelpers/ListingPageComponents'
import { getListItemsFromActivityPlanList } from '../ListingPageComponentsAndHelpers/ListingPageHelpers'
import { LoadingSpinner } from '../Loaders'
import PublicAppHeader from '../PublicAppHeader'

export default function ActivityPlanPublicListing({ isWebView = false }) {
  const [pageLoading, setPageLoading] = useState(false)
  const [activityPlanList, setActivityPlanList] = useState()

  const [pageNumber, setPageNumber] = useState(1)
  const [hasNextPage, setHasNextPage] = useState(true)

  async function pageSetup() {
    setPageLoading(true)
    const resp = await getFeatureList('activity-plan')
    if (resp?.status === 200) {
      setActivityPlanList(resp?.data)
    }
    setPageLoading(false)
  }

  async function getNextActivityPlanPage() {
    const nextPageNumber = pageNumber + 1

    const resp = await getFeatureList('activity-plan', nextPageNumber)

    if (resp?.status === 200) {
      if (resp?.data && resp?.data?.length > 0) {
        setPageNumber(nextPageNumber)
        setActivityPlanList((prev) => [...prev, ...resp?.data])
      } else {
        // If there's no more data to load, set hasNextPage to false
        setHasNextPage(false)
      }
    } else {
      setHasNextPage(false)
    }
  }

  const [sentryRef] = useInfiniteScroll({
    hasNextPage,
    onLoadMore: getNextActivityPlanPage,
    rootMargin: '0px 0px 20px 0px',
  })

  useEffect(() => {
    pageSetup()
  }, [])

  return (
    <>
      <SEOComponent
        title="Explore AUMHUM Plans | AUMHUM"
        description="Find the right AUMHUM plan for you and start your journey to better well-being."
        image={APP_CONSTANTS.APP_LOGO_LINK}
        keywordsArr={['plans', 'subscription', 'help']}
      />
      {pageLoading ? (
        <LoadingSpinner bgColor="#F5F5F599" dark />
      ) : (
        <>
          {!isWebView && <PublicAppHeader config={{ showLinks: true }} />}
          <PublicListingComponentVarOne
            heading="Get a plan with AUMHUM today!"
            description="Find the right AUMHUM plan for you and start your journey to better well-being."
            actionText="Start Now"
            listItemsArray={getListItemsFromActivityPlanList(activityPlanList)}
            sentryRef={sentryRef}
            hasNextPage={hasNextPage}
          />
        </>
      )}
    </>
  )
}
